import React from "react";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import { BiLinkExternal } from "react-icons/bi";
import { AiFillGithub } from "react-icons/ai"
import { DiReact} from "react-icons/di"
import { DiJavascript1 } from "react-icons/di"
import { DiHtml5 } from "react-icons/di"
import { DiCss3 } from "react-icons/di"
import { SiRedux } from "react-icons/si";
import {SiMaterialUi} from "react-icons/si";
import {FaNodeJs} from "react-icons/fa";

function ProjectCards(props) {
  return (
    <Card className="project-card-view">
      <Card.Img variant="top" src={props.imgPath} alt="card-img" />
      <Card.Body>
        <Card.Title><h4>{props.title}</h4></Card.Title>
        <Card.Text style={{ textAlign: "left", fontSize:"1.2rem"}}>
          {props.description}
        </Card.Text>
        <Card.Title style={{textAlign:"left", textDecoration:"underline"}}><h5>About</h5></Card.Title>
        <Card.Text style={{ textAlign: "left", fontSize:"1.1rem"}}>
          {props.about}
        </Card.Text>
        <div>
          <h5 style={{color:"#cd5ff8", fontSize:"1.4rem"}}>Tech stack</h5>
        {props.title === "airbnb"?
        <div style={{display:"flex", alignItems:"center", justifyContent:"center",flexWrap:"wrap",marginBottom:"10px"}}>
            <div style={{margin:"2%"}}><DiReact style={{fontSize:"35px"}}/></div>
            <div style={{margin:"2%"}}><SiRedux style={{fontSize:"35px"}}/></div>
            <div style={{margin:"2%"}}><SiMaterialUi style={{fontSize:"35px"}}/></div>
            <div style={{margin:"2%"}}><DiJavascript1 style={{fontSize:"35px"}}/></div>
            <div style={{margin:"2%"}}><DiHtml5 style={{fontSize:"35px"}}/></div>
            <div style={{margin:"2%"}}><DiCss3 style={{fontSize:"35px"}}/></div>
        </div>
          :props.title === "onnbikes" ?
        <div style={{display:"flex", alignItems:"center", justifyContent:"center",flexWrap:"wrap",marginBottom:"10px"}}>
          <div style={{margin:"2%"}}><DiJavascript1 style={{fontSize:"35px"}}/></div>
          <div style={{margin:"2%"}}><DiHtml5 style={{fontSize:"35px"}}/></div>
          <div style={{margin:"2%"}}><DiCss3 style={{fontSize:"35px"}}/></div>
        </div>
        : <div style={{display:"flex", alignItems:"center", justifyContent:"center",flexWrap:"wrap",marginBottom:"10px"}}>
        <div style={{margin:"2%"}}><DiReact style={{fontSize:"35px"}}/></div>
        <div style={{margin:"2%"}}><FaNodeJs style={{fontSize:"35px"}}/></div>
        <div style={{margin:"2%"}}><SiRedux style={{fontSize:"35px"}}/></div>
      </div>
        }
        </div>
        <Button style={{margin:"5px"}} variant="primary" href={props.codelink} target="_blank">
          <AiFillGithub /> &nbsp;
          code
        </Button>
        <Button style={{margin:"5px"}} variant="primary" href={props.link} target="_blank">
          <BiLinkExternal /> &nbsp;
          Demo
        </Button>
      </Card.Body>
    </Card>
  );
}
export default ProjectCards;
